import React from 'react';
import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';
import { PRODUCT_FRAGMENT } from '../../../component/productPreview/ProductPreview';
import ProductsListItem from '../../../component/productsList/productsListItem/ProductsListItem';
import { useMounted } from '../../../hook/useMounted';

import './DealsOfTheWeek.css';

const DEALS_PRODUCTS = gql`
  query DealsOfTheWeek($filter: ProductFilter!, $sort: String!, $limit: Int!) {
    items: searchProducts(filter: $filter, sort: $sort, limit: $limit) {
      ...ProductFragment
      id
      createdAt
      category
      title
      brand
      price
      original_price
      status
      external_url
      resizedSmallImages
      is_visible
      size
      condition
      discount_rate
      like_count
      is_liked
    }
  }
  ${PRODUCT_FRAGMENT}
`;

/**
 * 홈화면 득템아이템 섹션
 * @returns {JSX.Element}
 * @constructor
 */
export default function DealsOfTheWeek() {
    const mounted = useMounted();
    const { data } = useQuery(DEALS_PRODUCTS, {
        variables: {
            filter: {
                price_max: 100000,
                show_only: 'selling',
            },
            sort: 'NEW',
            limit: 6,
        },
        skip: !mounted,
        fetchPolicy: 'cache-and-network',
    });

    if (!mounted) return null;

    const items = data?.items ?? [];

    return (
        <section className="DealsOfTheWeek">
            <div className="DealsOfTheWeek-inner">
                <div className="DealsOfTheWeek-header">
                    <div>
                        <div className="DealsOfTheWeek-tag">Deals of the Week</div>
                        <h2 className="DealsOfTheWeek-title">득템 아이템</h2>
                    </div>
                </div>
                <div className="DealsOfTheWeek-grid">
                    {items.map((product) => (
                        <ProductsListItem key={product.id} product={product} />
                    ))}
                </div>
            </div>
        </section>
    );
}
